import React from "react";

const Section6Legal = () => (
  <>
    <h2>6. Legal Basis for Processing Personal Data</h2>
    <p>
    All processing of personal data by Comparedly Ltd. is carried out in strict adherence to the lawful bases for processing as outlined in Article 6(1) of both the GDPR and the UK GDPR.
    </p>

    <p>
    For the purpose of providing and improving the Comparedly.com service, we primarily rely on the legal basis of <strong> performance of a contract </strong> as the processing is necessary for us to deliver the services agreed upon in our terms of service. Additionally, we process data for this purpose based on our <strong> legitimate interests </strong> in ensuring the ongoing functionality, security, and improvement of our platform, as well as in understanding how users interact with our service to optimize their experience. These interests are carefully balanced against the rights and freedoms of our users.
    </p>
  
    <p>
    The processing of personal data for managing user accounts is also primarily based on the <strong> performance of a contract </strong> , as this processing is essential for us to provide users with access to and control over their accounts. 
    </p>
  
    <p>
    When processing payments from users, we do so on the legal basis of <strong> performance of a contract </strong> , as this processing is necessary to fulfill our obligations to users who subscribe to our paid services.
    </p>
  
    <p>
    For sending essential service updates and providing crucial support messages, we rely on our <strong> legitimate interests </strong>  in keeping users informed about important platform changes and ensuring they receive the assistance they need to effectively use our service. For marketing messages that extend beyond essential service updates, we will only process your data if you have provided us with your explicit <strong > consent </strong>.
    </p>

    <p>
    Personalizing the user experience is also based on our <strong> legitimate interests </strong>  in providing a more relevant and efficient platform experience. We have carefully balanced this interest against the rights and freedoms of our users to ensure that their privacy is not unduly affected.
    </p>

    <p>
    In certain circumstances, we may need to process personal data to comply with a <strong> legal obligation </strong>  to which Comparedly Ltd. is subject, such as responding to requests from regulatory authorities or complying with applicable laws.
    </p>

    <p>
    Finally, for marketing and promotional purposes, we will only process your personal data if you have given us your freely given, specific, informed, and unambiguous <strong > consent </strong>. You have the right to withdraw this consent at any time by contacting us or using the unsubscribe links provided in our marketing communications.
    </p>

    <p>
    Our legitimate interests for processing personal data include improving our service, understanding user behavior, conducting direct marketing of similar services (with opt-out options), and preventing fraud and abuse. We have conducted thorough assessments to ensure that these interests do not override your fundamental rights and freedoms.
    </p>
  
  </>
);

export default Section6Legal;
